export enum ClaimStep {
	ContactData = 0,
	ClaimData = 1,
	ConfirmClaim = 2,
	ClaimRegister = 3
}
